import { modalComponentModule } from '../../../../shared/app/components/modal/modal';
import resetCodeDialogTemplate from './reset-code-dialog.tpl.html';
import './reset-code-dialog.less';

export const resetCodeComponentModule = angular
  .module('Q.components.reset-code-dialog', [modalComponentModule])

  .factory('resetCodeDialog', function resetCodeDialog($modal) {
    return {
      open(challengeProcess) {
        return $modal.openOnce('resetCodeDialog', {
          template: resetCodeDialogTemplate,
          controller: 'ResetCodeDialogCtrl as $ctrl',
          resolve: {
            challengeProcess: () => challengeProcess,
          },
        }).result;
      },
    };
  })
  .controller(
    'ResetCodeDialogCtrl',
    function ResetCodeDialogCtrl($modalInstance, challengeProcess) {
      const ctrl = this;

      ctrl.$onInit = () => {
        ctrl.testCasesEnabled =
          challengeProcess.solution &&
          challengeProcess.solution.sampleTestCasesEnabled &&
          !challengeProcess.solution.sampleTestCasesReadOnly;
      };

      ctrl.cancel = () => $modalInstance.dismiss();

      ctrl.reset = (type) => {
        ctrl.processing = true;
        challengeProcess
          .reset(type)
          .then(ctrl.cancel)
          .catch(() => {
            ctrl.processing = false;
          });
      };
    },
  );
